// /srv/docker/develop/strike.hu_51200-51220/next/components/navigation/MainMenu.jsx

"use client";

import Link from "next/link";
import {
    usePathname,
} from "next/navigation";

import {
    useLanguage,
} from "@/components/LanguageContext";

import {
    ROUTES,
} from "@/lib/localizedRoutes";

import {
    brandConfig,
} from "@/lib/brandConfig";

export const menuItems =
    ROUTES
        .filter(
            (route) =>
                route.menu
                    ?.showInHeader ===
                true
        )
        .map(
            (route) => ({
                key:
                    route.key,

                label:
                    route.label,

                paths:
                    route.paths,

                href:
                    route.paths.hu,

                showInLinks:
                    route.menu
                        ?.showInLinks ===
                    true,
            })
        );

export default function MainMenu({
    onItemClick,
    variant = "header",
}) {
    const pathname =
        usePathname();

    const {
        language,
    } =
        useLanguage();

    const isHeader =
        variant === "header";

    const brandStyle = {
        "--brand-primary":
            brandConfig.colors.primary,
    };

    const navigationLabel =
        language === "hu"
            ? (
                isHeader
                    ? "Főmenü"
                    : "Lábléc menü"
            )
            : (
                isHeader
                    ? "Main menu"
                    : "Footer menu"
            );

    return (
        <nav
            style={brandStyle}
            aria-label={
                navigationLabel
            }
            className={
                isHeader
                    ? `
                        mx-auto flex min-h-[520px] w-full max-w-[430px]
                        items-center justify-center px-8 py-12
                        md:max-w-none
                    `
                    : `
                        mt-8 flex flex-col items-center
                        text-white
                    `
            }
        >
            <ul
                className={
                    isHeader
                        ? "flex flex-col items-center gap-[14px]"
                        : "flex flex-col items-center gap-3"
                }
            >
                {menuItems.map((item) => {
                    const localizedHref =
                        item.paths[
                            language
                        ] ||
                        item.paths.hu;

                    const isActive =
                        pathname ===
                        localizedHref;

                    const itemLabel =
                        item.label[
                            language
                        ] ||
                        item.label.hu;

                    return (
                        <li
                            key={
                                item.key
                            }
                        >
                            <Link
                                href={
                                    localizedHref
                                }
                                onClick={
                                    onItemClick
                                }
                                className={
                                    isHeader
                                        ? `
                                            block text-center text-[21px]
                                            font-normal leading-tight
                                            transition-colors duration-200
                                            md:text-[24px]
                                            ${isActive
                                                ? "text-[var(--brand-primary)]"
                                                : "text-white hover:text-[var(--brand-primary)]"
                                            }
                                        `
                                        : `
                                            block text-center text-[20px]
                                            leading-none text-neutral-300
                                            transition-colors duration-200
                                            hover:text-[var(--brand-primary)]
                                            md:text-[16px]
                                            ${isActive
                                                ? "text-[var(--brand-primary)]"
                                                : ""
                                            }
                                        `
                                }
                            >
                                {itemLabel}
                            </Link>
                        </li>
                    );
                })}
            </ul>
        </nav>
    );
}